module.exports = __webpack_public_path__ + "img/bindChat_c.306f72ed.png";